import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import AppDialog from "~/shared/ui/AppDialog";
import { packageContext } from "~/components/modals/packageContext";

// Ruling P6: o contrato só traz mergedIntoAdvancePaymentId, então o texto não cita o número do pacote irmão.
export default function MergedPackageDialog({ open, packageId, mergedIntoId, onClose, onOpen }) {
  return (
    <AppDialog
      open={open}
      onClose={onClose}
      size="sm"
      title={`Este pacote foi agrupado no #${mergedIntoId}`}
      context={packageContext({ id: packageId })}
      actions={
        <>
          <Button onClick={onClose} sx={{ color: "text.primary" }}>
            Fechar
          </Button>
          <Button variant="contained" onClick={() => onOpen(mergedIntoId)}>
            Abrir pacote #{mergedIntoId}
          </Button>
        </>
      }
    >
      <Typography paragraph>
        Enquanto você conferia, o pacote #{packageId} foi juntado com outro pacote do mesmo médico e da mesma empresa e agora faz parte do{" "}
        <b>pacote #{mergedIntoId}</b>.
      </Typography>
      <Typography>
        <b>Nada do que você fez foi perdido.</b> As datas e conferências já salvas seguiram para o #{mergedIntoId}. Esta ação não alterou nada.
      </Typography>
    </AppDialog>
  );
}
